import { render, staticRenderFns } from "./CompanyUsersPage.vue?vue&type=template&id=3f15c70d&scoped=true"
import script from "./CompanyUsersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyUsersPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyUsersPage.vue?vue&type=style&index=0&id=3f15c70d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15c70d",
  null
  
)

export default component.exports